import React from "react";
import { FaTv, FaHdd, FaBolt, FaWifi, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

function TelevisionDetails({ product }) {
    if (!product) return <p className="productspec-error">Məhsul detalları yüklənmir...</p>;

    const getStatus = (val, yes = "Bəli", no = "Xeyr") =>
        val === true ? yes : val === false ? no : "Bilinmir";

    const specs = [
        { label: "Ad", value: product.name, icon: <FaTv /> },
        { label: "Şəhər", value: product.city },
        { label: "Kateqoriya", value: product.categoryName },
        { label: "Sub-kateqoriya", value: product.subCategoryName },
        { label: "Marka", value: product.brandName },
        { label: "Model", value: product.modelName },
        { label: "Ekran Ölçüsü", value: product.screenSize ? `${product.screenSize} inch` : null },
        { label: "Qətnamə", value: product.resolution },
        { label: "Smart TV", value: getStatus(product.isSmartTv), status: product.isSmartTv },
        { label: "Ekran Növü", value: product.screenType },
        { label: "HDMI Portları", value: product.hdmiPorts, icon: <FaHdd /> },
        { label: "Enerji İstifadəsi", value: product.powerConsumption ? `${product.powerConsumption} W` : null, icon: <FaBolt /> },
        { label: "Əməliyyat Sistemi", value: product.operatingSystem },
        { label: "Bluetooth", value: getStatus(product.hasBluetooth, "Var", "Yoxdur"), status: product.hasBluetooth },
        { label: "Wi-Fi", value: getStatus(product.hasWifi, "Var", "Yoxdur"), status: product.hasWifi, icon: <FaWifi /> },
        { label: "Yenilənmə Tezliyi", value: product.refreshRate ? `${product.refreshRate} Hz` : null },
        { label: "Səs Gücü", value: product.audioOutputPower ? `${product.audioOutputPower} W` : null },
        { label: "USB Portları", value: product.usbPorts },
        { label: "Səs ilə idarəetmə", value: getStatus(product.hasVoiceControl), status: product.hasVoiceControl },
        { label: "4K Dəstəyi", value: getStatus(product.supports4K, "Var", "Yoxdur"), status: product.supports4K },
        { label: "Enerji Səmərəliliyi", value: product.energyEfficiencyClass },
        { label: "Çəki", value: product.weight ? `${product.weight} kg` : null },
        { label: "Ölçülər", value: product.dimensions },
        { label: "İstehsal İli", value: product.yearOfManufacture },
        { label: "Divara Montaj", value: getStatus(product.hasWallMountSupport), status: product.hasWallMountSupport }
    ];

    return (
        <div className="productspec-container productspec-container--electronics">
            <div className="productspec-header">
                <FaTv className="productspec-header__icon" />
                <h3 className="productspec-header__title">Televizor Məlumatları</h3>
            </div>

            <div className="productspec-grid">
                {specs.map((spec, index) => {
                    if (!spec.value || spec.value === "Bilinmir") return null;
                    
                    return (
                        <div key={index} className="productspec-item">
                            {spec.icon && <span className="productspec-item__icon">{spec.icon}</span>}
                            <div className="productspec-item__content">
                                <span className="productspec-item__label">{spec.label}</span>
                                <span className={`productspec-item__value ${spec.status !== undefined ? (spec.status ? 'productspec-item__value--success' : 'productspec-item__value--neutral') : ''}`}>
                                    {spec.status !== undefined && (
                                        spec.status ? <FaCheckCircle className="productspec-status-icon productspec-status-icon--success" /> : <FaTimesCircle className="productspec-status-icon productspec-status-icon--neutral" />
                                    )}
                                    {spec.value}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {product.description && (
                <div className="productspec-description">
                    <h4 className="productspec-description__title">Əlavə Təsvir</h4>
                    <p className="productspec-description__text">{product.description}</p>
                </div>
            )}
        </div>
    );
}

export default TelevisionDetails;